import { Box, Typography, useTheme } from '@mui/material';
import { InfoWindow, Marker } from '@vis.gl/react-google-maps';
import { GoogleMapsMarkerInfo } from 'types/google-maps/google-maps-marker-info.type';
import React, { useMemo, useState } from 'react';
import markerIcon from '../assets/marker.svg';

type Props = { marker: GoogleMapsMarkerInfo };

const SiteMarker: React.FC<Props> = ({ marker }) => {
  const theme = useTheme();

  const [open, setOpen] = useState<boolean>(false);

  const popupInfo = useMemo(
    () => ({
      text: String(marker.name) || '',
      url: marker.url || '',
      lat: marker.lat,
      lng: marker.lng,
    }),
    [marker]
  );

  const PopupWindow = () => {
    return (
      popupInfo && (
        <InfoWindow
          pixelOffset={[0, -30]}
          position={{
            lat: popupInfo.lat,
            lng: popupInfo.lng,
          }}
          onCloseClick={() => setOpen(false)}>
          <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} overflow={'none'} paddingX={4} paddingY={2}>
            <Typography sx={{ color: theme.palette.darkBlue.main, padding: 2, fontWeight: 500, textAlign: 'center' }}>
              {popupInfo.text}
            </Typography>
          </Box>
        </InfoWindow>
      )
    );
  };

  return (
    <>
      <Marker
        opacity={1}
        position={{ lat: marker.lat, lng: marker.lng }}
        title={marker.name}
        icon={markerIcon}
        zIndex={0}
        onClick={() => {
          setOpen((prev) => !prev);
        }}
      />
      {open && PopupWindow()}
    </>
  );
};

export default React.memo(SiteMarker);
